
export const headers = [
  { text: 'No', align: 'start', value: 'number_index', sortable: false, width: '10' },
  { text: '', value: 'custom', align: 'center', sortable: false, width: '10', },
  { text: 'NMID', value: 'nmid', width: '150', align: 'start', sortable: false },
  { text: 'MID', value: 'mid_bank', width: '200', align: 'start', sortable: false },
  { text: 'RRN', value: 'rrn', width: '150', align: 'start', sortable: false},
  { text: 'Metode', value: 'payment_channel', width: '150', align: 'center', sortable: false },
  { text: 'MPAN', value: 'mpan', width: '150', align: 'center', sortable: false },
  { text: 'Trx Date', value: 'trx_date', width: '150', align: 'center', sortable: false },
  { text: 'Trx Time', value: 'trx_time', width: '150', align: 'center', sortable: false },
  { text: 'Action', value: 'action', width: '100', align: 'center', sortable: false },
];

export const search = {
  nmid: '',
  mid: '',
  mid_bank: '',
  rrn: '',
  payment_channel: '',
  mpan: '',
  trx_date: '',
  trx_time: '',
  maintenance_type: "4"
};

export const editedItem = {
  nmid: '',
  mid: '',
  mid_bank: '',
  rrn: '',
  payment_channel: '',
  mpan: '',
  trx_date: '',
  trx_time: '',
  maintenance_type: "4"
};
